import { ElectronApi } from '@/services/electron.api';
import { WatchfaceService } from '@/services/watchface';
import { loadVideoDom } from '@/utils/fs/video.utils';

export const useShapeVideo = () => {
  const loadData = (videoEl: HTMLVideoElement) => {
    videoEl.muted = true;
    videoEl.autoplay = true;
    videoEl.pause();
    try {
      return new Promise((resolve, reject) => {
        videoEl.onloadeddata = () => {
          resolve(videoEl);
        };
        videoEl.onerror = () => {
          reject();
        };
      });
    } catch (error) {
      // console.log(error);
    }
  };
  const toVideoDoms = async (
    videos: { basename: string; realpath: string }[],
    options?: {
      autoLoadData: boolean;
    }
  ) => {
    const res: {
      [key: string]: HTMLVideoElement;
    } = {};
    for (const video of videos) {
      const { basename, realpath } = video;
      try {
        const videoEl = await loadVideoDom(realpath ?? '');
        if (videoEl) {
          if (options?.autoLoadData) await loadData(videoEl);
          res[basename] = videoEl;
        }
      } catch (error) {
        // console.log(error);
      }
    }
    return res;
  };

  /**
   *  获取watchface中所有视频文件的src
   * @param watchfaceAst
   * @param watchfacePath
   * @returns
   */
  const getVideoSrcsFromAst = (watchfaceAst: Ast, watchfacePath?: string) => {
    const fileAsts =
      watchfaceAst.children
        .find((item) => item.tag == 'Resources')
        ?.children.filter((item) => {
          return item.tag == 'File' && item.attrsMap.fileName?.endsWith('.mp4');
        }) ?? [];
    const res: { basename: string; realpath: string }[] = [];

    const resourcePath = new WatchfaceService(watchfacePath ?? undefined)
      .ResourcePath;
    fileAsts.forEach((item) => {
      const basename = item.attrsMap.fileName;
      res.push({
        basename,
        realpath: ElectronApi.path?.join(resourcePath, basename) ?? ''
      });
    });

    return res;
  };

  return {
    toVideoDoms,
    getVideoSrcsFromAst
  };
};
